/**
 *  Get data
 */
async function getPoints() {
    let str = `https://admin.zrp-site.tools/wp-json/zrp-point-of-sale/v2/site/points?favorite=1&fields=city_id,country_id`;

    let response = await fetch(str);

    if (response.ok) {
        
        const list = await response.json();
        return list.map((item)=>{
            item.name = item.name
            .replace('Zielinski &amp; Rozen Perfumerie ', '')
            .replace('Zielinski &amp; Rozen perfumerie ', '')
            .replace('Zielinski &amp; Rozen ', '');
            return item;
        });
    }
};

/**
 *  Get countries
 */
async function getCountries() {
    let str = `https://admin.zrp-site.tools/wp-json/zrp-point-of-sale/v2/site/countries`;

    let response = await fetch(str);

    if (response.ok) {
        const countries = await response.json();
        return getFormatAsDict(countries);
    }
}

/**
 * Counties and cities as dict
 */
function getFormatAsDict(countries) {
    const result = {};
    countries.forEach(country => {
        if (country.country_id) {
            result[country.country_id] = country.country_name;
            if (country.cities) {
               country.cities.forEach(city => {
                result[city.city_id] = city.city_name;
               });
            }
        }
    });
    return result;
}

/**
 * Mouse over on item
 */
function handleMouseOver(index) {

    const curImgActiveEl = document.querySelector('.zrp-stores-imgs__item--active');
    const curItemActiveEl = document.querySelector('.zrp-stores-list__item--active');
    
    const itemEls = document.querySelectorAll('.zrp-stores-list__item');
    const imgEls = document.querySelectorAll('.zrp-stores-imgs__item');

    if (imgEls[index] && curImgActiveEl && curImgActiveEl != imgEls[index]) {
        if (curImgActiveEl && curItemActiveEl) {
            curImgActiveEl.classList.remove('zrp-stores-imgs__item--active');
            curItemActiveEl.classList.remove('zrp-stores-list__item--active');
        }

    
        imgEls[index].classList.add('zrp-stores-imgs__item--active');
        itemEls[index].classList.add('zrp-stores-list__item--active');
    }
 
}

/**
 * Create list element
 * @param {object} item
 */
function createItem(item, dict, index) {
    const rootEl = document.createElement('div');
    const nameEl = document.createElement('div');
    const addrEl = document.createElement('a');

    rootEl.classList.add('zrp-stores-list__item');
    nameEl.classList.add('zrp-stores-list__name');
    addrEl.classList.add('zrp-stores-list__addr');

    rootEl.onmouseover = function() {
        handleMouseOver(index);
    }

    if (dict) {

        // City
        // if(dict[item.city_id]) {
        //     nameEl.innerHTML = `<span><span>${index >= 9 ? index + 1 : '0' + (index + 1)}.</span>${dict[item.city_id]}</span>`;
        // }

        // Name
        nameEl.innerHTML = `<span><span>${index >= 9 ? index + 1 : '0' + (index + 1)}.</span>${item.name}</span>`;


        // Country
        if(dict[item.country_id]) {
            nameEl.innerHTML += `<span>${dict[item.country_id]}</span>`;
        }
        
    }

    addrEl.target = '_blank';
    addrEl.rel = 'nofollow noreferer';
    addrEl.href = `https://www.google.com/maps/search/${item.name.replace(/\s/g,'+').replace(/&amp;/g,'&')}/@${item.lat},${item.lng},16z`
    addrEl.innerHTML = item.address;
    
    rootEl.appendChild(nameEl);
    rootEl.appendChild(addrEl);

    return rootEl;
}

/**
 * Create img element
 * @param {object} item
 */
function createImg(item) {
    const rootEl = document.createElement('div');
    const imgEl = document.createElement('img');

    rootEl.classList.add('zrp-stores-imgs__item');
    imgEl.classList.add('zrp-stores-imgs__img')

    imgEl.alt = item.name;
    imgEl.src = item.photo[0] + '.webp';
    imgEl.loading = 'lazy';
    imgEl.width = '2000';
    imgEl.height = '2000';

    rootEl.appendChild(imgEl);

    return rootEl;
}

/**
 *  Initialization
 */
async function initStores() {
    const listEl = document.querySelector('.zrp-stores-list');
    const imgsEl = document.querySelector('.zrp-stores-imgs');

    if (listEl && imgsEl) {

        const list = await getPoints();
        const dict = await getCountries();

        if (dict && list && list.length > 0) {
            list.forEach(function(item, index) {
                
                const imgEl = createImg(item);
                const itemEl = createItem(item, dict, index);

                // First element as active
                if (index == 0) {
                    imgEl.classList.add('zrp-stores-imgs__item--active');
                    itemEl.classList.add('zrp-stores-list__item--active');
                }

                listEl.appendChild(itemEl);

                imgsEl.appendChild(imgEl);
            });
        }
        
    }
}

document.addEventListener("DOMContentLoaded", initStores);